import React, { useEffect } from "react";
import styles from "./invoice.module.css";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOrderDetailsThunk } from "../../../redux/orderSlice";
import { formatedate } from "../../../helper/utils";
import numberToWords from "number-to-words";

const Invoice = () => {
    const { id } = useParams();
    const dispatch = useDispatch()
    const { orderDetails, isLoading, isRefresh } = useSelector(state => state.orders)
    const orderData = orderDetails?.data
    // console.log('orderdata================', orderData);


    useEffect(() => {
        dispatch(getOrderDetailsThunk(id))
    }, [isRefresh, id, dispatch])
    
    // Variables to store total price and GST details
    let totalPriceBeforeGst = 0;

    // Iterate through products to extract price before GST and GST amounts
    const productsWithGst = orderData?.products?.map((item) => {
        const totalPriceWithGst = item?.totalPrice || 0;
        const gstInPercentage = item?.gst || 0;

        // Calculate price before GST for each product
        const priceBeforeGst = totalPriceWithGst / (1 + gstInPercentage / 100);
        
        // Calculate the GST amount for each product
        
        // Accumulate the total price before GST and total GST amount
        totalPriceBeforeGst += priceBeforeGst;
    });
    
    console.log('totalPriceBeforeGst',totalPriceBeforeGst);
    const subTotal = orderData?.subTotal || 0;
    const SGST =  (totalPriceBeforeGst * 1.5) / 100 || 0;
    const CGST = (totalPriceBeforeGst * 1.5) / 100 || 0;
    const totalAmount = totalPriceBeforeGst + SGST + CGST;
    
    return (
        <div className={styles.invoice}>
            <header className={styles.header}>
                <div style={{ display: 'flex', gap: "10px", alignItems: "center" }}>
                    <img src="/assets/invoice.png" width={40} height={40} />
                    <div >
                        <h1>INVOICE</h1>
                        <p>pavithra jewel's</p>
                    </div>
                </div>
                <div className={styles.companyDetails}>
                    <strong>#{orderData?._id}</strong>
                    <p>INVOICE NUMBER</p>
                </div>
            </header>

            <section className={styles.toFrom}>
                <div>
                    <p style={{ color: "#FF451C" }}>TO</p>
                    <strong>{orderData?.shippingAddress?.firstName}{" "}{orderData?.shippingAddress?.lastName}</strong>
                    <p>{orderData?.shippingAddress?.streetAddress},</p>
                    <p>{orderData?.shippingAddress?.unit}, {orderData?.shippingAddress?.city}</p><br />
                    <p>PAN: {orderData?.panNumber}</p>
                    <p>Contact: {orderData?.shippingAddress?.phone}</p>
                    <p>State: {orderData?.shippingAddress?.state}</p>
                    <p>State Code: {orderData?.shippingAddress?.pincode}</p>
                    <p>GSTIN/Unique ID: URD</p>
                </div>
                <div>
                    <p style={{ color: "#FF451C" }}>FROM</p>
                    <strong>Company</strong>
                    <p>4th street, 3 main,</p>
                    <p>Kalyan Nagar, Bangalore</p><br />
                    <p>Contact: 9876543210</p>

                </div>
                <section className={styles.invoiceDetails}>
                    <div>
                        <p><strong>Date:</strong> {formatedate(orderData?.createdAt)}</p>
                        <p><strong>State:</strong> {orderData?.shippingAddress?.state}</p>
                        <p><strong>State</strong> Code: {orderData?.shippingAddress?.pincode}</p>
                    </div>
                </section>
            </section>


            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>SL NO</th>
                        <th>NAME OF THE GOODS SUPPLIED</th>
                        <th>HSN</th>
                        <th>QTY in Grams</th>
                        <th>GOLD RATE</th>
                        <th>TOTAL</th>
                    </tr>
                </thead>
                <tbody>

                    {orderData?.products?.map((item, index) => (
                        <tr>
                            <td>{index + 1}</td>
                            <td><strong>{item?.productId?.productName}</strong>
                                <br />Making charges: {item?.productId?.pricing?.makingCharges?.value || 0}%
                                <br />Stone charges: ₹{item?.productId?.pricing?.stoneCharges?.value || 0}
                            </td>
                            <td>{item?.productId?.inventory?.sku}</td>
                            <td>{item?.productId?.pricing?.totalWeight?.value}</td>
                            <td>₹{item?.productId?.gold?.type === 'k22' ? orderData?.goldRate22k : orderData?.goldRate18k}</td>
                            <td>₹{item?.totalPrice?.toFixed(2)}</td>
                        </tr>
                    ))}


                </tbody>
            </table>

            <section className={styles.totals}>
                <div style={{ paddingBottom: "4px", display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #00000033' }}>
                    <div style={{ width: '70%' }}>Total Amount before tax GST ( SGST / UGST / CGST / IGST )</div>
                    <div style={{ width: '20%' }}></div>
                    <div style={{ width: '10%' }}> <strong>₹{totalPriceBeforeGst?.toFixed(2)}</strong></div>
                </div>
                <div className={styles.totals} >
                    <div style={{ display: 'flex', }}>
                        <div style={{ width: '70%' }}></div>
                        <div style={{ width: '20%' }}> <strong>IGST (3%):</strong></div>
                        <div style={{ width: '10%' }}></div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '70%' }}></div>
                        <div style={{ width: '20%' }}> <strong>SGST (1.5%):</strong></div>
                        <div style={{ width: '10%' }}>₹{SGST?.toFixed(2)}</div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '70%' }}></div>
                        <div style={{ width: '20%' }}> <strong>CGST (1.5%):</strong></div>
                        <div style={{ width: '10%' }}>₹{CGST?.toFixed(2)}</div>
                    </div>
                </div>
                <div style={{ paddingBottom: "4px", display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #00000033' }}>
                    <div style={{ width: '70%' }}>Total Amount Payable inclusive of  GST tax ( SGST / UGST / CGST / IGST)</div>
                    <div style={{ width: '20%' }}><strong>TOTAL AMOUNT</strong></div>
                    <div style={{ width: '10%' }}> <strong>₹{totalAmount?.toFixed(2)}</strong></div>
                </div>
                <div style={{ padding: "6px 0px", display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #00000033' }}>
                    <div style={{ width: '70%',textTransform:'uppercase' }}>Inwords: <strong>INR {numberToWords.toWords(Number(orderData?.total))} </strong></div>
                    <div style={{ width: '20%' }}></div>
                    <div style={{ width: '10%' }}> </div>
                </div>
            </section>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", fontSize: "10px", margin: "30px 0px", color: '#484B4E' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: "8px", width: "60%" }}>
                    <strong>DECLARATION:</strong>
                    <p>
                        1) We declare that this invoice shows actual price of the goods
                        described and that all particulars are true and correct.
                    </p>
                    <p>
                        2) Error and Omission in this invoice shall be subject to the
                        jurisdiction of the Bangalore
                    </p>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: "center", gap: "8px" }}>
                    <strong>FOR PAWTHIRA JEWELS</strong>
                    <p style={{ marginTop: '20px' }}>Customer Sign</p>
                    <strong>AUTHORIZED SIGNATORY</strong>
                </div>
            </div>

        </div>
    );
};

export default Invoice;
